// extracted by mini-css-extract-plugin
export var marginBottomLg = "HorizontalSpacing-module--margin-bottom-lg--fdf62";
export var marginBottomMd = "HorizontalSpacing-module--margin-bottom-md--a2605";
export var marginBottomSm = "HorizontalSpacing-module--margin-bottom-sm--825aa";
export var marginBottomXl = "HorizontalSpacing-module--margin-bottom-xl--d1b2e";
export var marginBottomXs = "HorizontalSpacing-module--margin-bottom-xs--e3e1a";
export var marginBottomXxl = "HorizontalSpacing-module--margin-bottom-xxl--c7e92";
export var marginTopLg = "HorizontalSpacing-module--margin-top-lg--be9e7";
export var marginTopMd = "HorizontalSpacing-module--margin-top-md--02058";
export var marginTopSm = "HorizontalSpacing-module--margin-top-sm--58747";
export var marginTopXl = "HorizontalSpacing-module--margin-top-xl--47b07";
export var marginTopXs = "HorizontalSpacing-module--margin-top-xs--06b27";
export var marginTopXxl = "HorizontalSpacing-module--margin-top-xxl--75be5";
export var paddingBottomLg = "HorizontalSpacing-module--padding-bottom-lg--d432a";
export var paddingBottomMd = "HorizontalSpacing-module--padding-bottom-md--86196";
export var paddingBottomSm = "HorizontalSpacing-module--padding-bottom-sm--ad9f5";
export var paddingBottomXl = "HorizontalSpacing-module--padding-bottom-xl--516f5";
export var paddingBottomXs = "HorizontalSpacing-module--padding-bottom-xs--417e0";
export var paddingBottomXxl = "HorizontalSpacing-module--padding-bottom-xxl--51ef1";
export var paddingTopLg = "HorizontalSpacing-module--padding-top-lg--8dfd3";
export var paddingTopMd = "HorizontalSpacing-module--padding-top-md--1c6c0";
export var paddingTopSm = "HorizontalSpacing-module--padding-top-sm--e50dc";
export var paddingTopXl = "HorizontalSpacing-module--padding-top-xl--1a16f";
export var paddingTopXs = "HorizontalSpacing-module--padding-top-xs--b095a";
export var paddingTopXxl = "HorizontalSpacing-module--padding-top-xxl--df1c1";